import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { getUserEmail } from '../user.utilities';

const useStyles = makeStyles((theme) => ({
  greeting: {
    padding: theme.spacing(3),
  },
}));

const Greeting = () => {
  const [email, setEmail] = React.useState(null);
  const classes = useStyles();

  React.useEffect(() => {
    getUserEmail().then((email) => {
      setEmail(email);
    });
  }, []);

  return <Typography className={classes.greeting}>{email}</Typography>;
};

export default Greeting;
